import inMemoryJWT from './inMemoryJWT';
import { fetchUtils } from 'react-admin';
import { stringify } from 'query-string';
import { apiBaseUrl } from './config';

const apiUrl= apiBaseUrl;

export default function patchesDataProvider (url) {
    const httpClient = (url, p_options) => {
        const options = {
            headers: new Headers({ Accept: 'application/json' }),
            ...p_options
        };
        const token = inMemoryJWT.getToken();
        if (token) {
            options.headers.set('x-access-token', `${token}`);
        }

        return fetchUtils.fetchJson(url, options);
    };

    return {
        getList: (resource, params) => {
            const { page, perPage } = params.pagination;
            const { field, order } = params.sort;
            const query = {
                sort: JSON.stringify([field, order]),
                range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
                filter: JSON.stringify(params.filter),
            };
            const url = `${apiUrl}/${resource}?${stringify(query)}`;

            return httpClient(url).then(function (response) {
                if (response.status < 200 || response.status >= 300) {
                    return Promise.reject(new Error("HTTP error" + response.status));
                }
                var ret_data = JSON.parse(response.body);

                var result = {};
                var records = Array.isArray(ret_data.result) ? ret_data.result : [];
                result.data = records.map(resource => ({ ...resource, id: resource._id }));
                if (ret_data.count != undefined) {
                    result.total = ret_data.count;
                } else {
                    result.total = records.length;
                }
                return result;
            });
        },

        getOne: (resource, params) => {
            return httpClient(`${apiUrl}/${resource}/${params.id}`).then(function (response) {
                if (response.status < 200 || response.status >= 300) {
                    return Promise.reject(new Error("HTTP error" + response.status));
                }
                var ret_data = JSON.parse(response.body);

                var result = {};
                result.data = ret_data.result;
                result.data.id = ret_data.result._id;
                return result;
            });
        },

        create: (resource, params) => {
            if (resource !== 'patches' || !params.data.script_file) {
                return Promise.reject(new Error(`Invalid request`));
            }

            const url_params = new URLSearchParams(
                {
                    device_type: params.data.device_type,
                    fw_compare_op: params.data.fw_compare_op,
                    fw_compare_ver: params.data.fw_compare_ver,
                    patch_compare_op: params.data.patch_compare_op,
                    patch_compare_ver: params.data.patch_compare_ver,
                    device_id_match: params.data.device_id_match,
                    description: params.data.description,
                    patch_ver: params.data.patch_ver,
                });
            var url = `${apiUrl}/patches?${url_params.toString()}`;

            let formData = new FormData();
            formData.append('script_file', params.data.script_file.rawFile);

            return httpClient(url, {
                method: 'POST',
                body: formData,
            }).then(function (response) {
                if (response.status < 200 || response.status >= 300) {
                    return Promise.reject(new Error("HTTP error" + response.status));
                }

                var ret_data = JSON.parse(response.body);
                var result = {};
                if (ret_data.result) {
                    result.data = ret_data.result;
                    result.data.id = ret_data.result._id;
                }
                return result;
            });
        },

        update: (resource, params) => Promise.reject('update not implemented'),
        updateMany: (resource, params) => Promise.reject('updateMany not implemented'),
        delete: (resource, params) => {
            return httpClient(`${apiUrl}/${resource}/${params.id}`, {
                method: 'DELETE',
            }).then(function (response) {
                if (response.status < 200 || response.status >= 300) {
                    return Promise.reject(new Error("HTTP error" + response.status));
                }

                var ret_data = JSON.parse(response.body);
                var result = {};
                if (ret_data.result == "ok") {
                    result.data = params.id;
                }
                return result;
            });
        },
        deleteMany: (resource, params) => Promise.reject('deleteMany not implemented'),
    };
};
